var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M418.02,148.26C389.457,42.187,280.187-21.326,173.765,6.57C66.905,34.584,2.76,144.312,30.773,251.172l0.274,1.042 l56.6,146.103V512h228.262v-88.768h114.131v-92.939l57.759-14.44L418.02,148.26z M391.996,300.589v84.598H277.865v88.768H125.69 v-82.751L67.311,240.509c-10.58-41.433-4.44-84.699,17.333-121.943c21.951-37.549,57.029-64.254,98.77-75.197 c41.743-10.941,85.409-4.878,122.957,17.07c37.548,21.951,64.253,57.027,75.196,98.769l0.333,1.273l53.787,129.183 L391.996,300.589z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "297.656,147.64 270.756,174.54 302.957,206.742 270.756,238.944 297.656,265.845 356.76,206.742  "
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "186.062,174.54 159.161,147.64 100.058,206.742 159.161,265.845 186.062,238.944 153.86,206.742  "
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "227.125,120.51 190.816,292.974 229.694,292.974 266.002,120.51  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThink);
export default __webpack_public_path__ + "static/media/think.b0a2e53bfe96adc81a19e6aa51b8dbdb.svg";
export { ForwardRef as ReactComponent };